import { TableCell, TableRow, TableFooter, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FORTA_BLUE } from '../../../../utils/colors';
import { usDollarFormatter } from '../../../../helpers';

interface IInvoiceReadOnlyPaymentTableFooterProps {
  total: number;
}

function InvoiceReadOnlyPaymentTableFooter({ total }: IInvoiceReadOnlyPaymentTableFooterProps) {
  const { t } = useTranslation('invoice');
  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={3}></TableCell>
        <TableCell
          colSpan={1}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            color: FORTA_BLUE.primary,
          }}
        >
          <Typography fontWeight={700} display="inline" mr={3}>
            {t('invoicePaymentTable.totalReceived')}
          </Typography>
          <Typography display="inline" textAlign={'right'} fontWeight={700}>
            {total || total === 0 ? usDollarFormatter.format(total) : ''}
          </Typography>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
}

export default InvoiceReadOnlyPaymentTableFooter;
